<template>
  <footer class="page-footer">
    <container>
      <div class="page-footer__row">
        <div class="page-footer__item">
          <p class="page-footer__info">
            © Miniatur Wunderland Hamburg GmbH
          </p>
          <p class="page-footer__links">
            <a
              :href="$t('terms.url')"
              rel="noopener"
            >{{ $t('terms.text') }}</a>
            <a
              :href="$t('privacy.url')"
              rel="noopener"
            >{{ $t('privacy.text') }}</a>
            <a
              :href="$t('imprint.url')"
              rel="noopener"
            >{{ $t('imprint.text') }}</a>
          </p>
        </div>

        <div class="page-footer__item">
          <p class="page-footer__info">
            {{ $t('help.text') }}<br>
            <a
              :href="$t('help.url')"
              rel="noopener"
            >{{ $t('help.linktext') }}</a>
          </p>
        </div>

        <div class="page-footer__item">
          <c-social-links />
        </div>
      </div>
    </container>
  </footer>
</template>

<script>
import container from './container.vue'
import CSocialLinks from './CSocialLinks.vue'

export default {
  name: 'CPageFooter',

  components: {
    container,
    CSocialLinks
  }
}
</script>

<i18n locale="en">
{
  "terms": {
    "text": "Terms & Conditions",
    "url": "https://www.miniatur-wunderland.com/services/terms-conditions/"
  },
  "privacy": {
    "text": "Privacy",
    "url": "https://www.miniatur-wunderland.com/services/privacy/"
  },
  "imprint": {
    "text": "Imprint",
    "url": "https://www.miniatur-wunderland.com/services/imprint/"
  },
  "help": {
    "text": "Feedback & support for the ticket-booking/-reservation:",
    "linktext": "Contact form",
    "url": "https://www.miniatur-wunderland.com/services/contact-us/ticket-booking-reservation"
  }
}
</i18n>

<i18n locale="de">
{
  "terms": {
    "text": "AGB",
    "url": "https://www.miniatur-wunderland.de/service/agb/"
  },
  "privacy": {
    "text": "Datenschutz",
    "url": "https://www.miniatur-wunderland.de/service/datenschutz/"
  },
  "imprint": {
    "text": "Impressum",
    "url": "https://www.miniatur-wunderland.de/service/impressum/"
  },
  "help": {
    "text": "Rückmeldung & Hilfe zur Ticket-Buchung/-Reservierung:",
    "linktext": "Kontaktformular",
    "url": "https://www.miniatur-wunderland.de/service/kontakt/ticket-buchung-reservierung/"
  }
}
</i18n>

<style lang="scss">
@import "../css/variables";

.page-footer {
  padding: $gutter-md 0 $gutter-lg;

  font-size: 0.875rem;
  text-align: center;
  background-color: #fff;

  @media (min-width: $breakpoint-lg) {
    text-align: left;
  }

  @media (min-width: $breakpoint-xl) {
    font-size: 1rem;
  }

  @media print {
    display: none;
  }
}

.page-footer__row {
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: $breakpoint-lg) {
    flex-direction: row;
    justify-content: space-between;
  }
}

.page-footer__item {
  @media (min-width: $breakpoint-lg) {
    &:first-child {
      margin-right: $gutter-sm;
    }

    &:nth-child(2) {
      text-align: center;
    }

    &:last-child {
      margin-left: $gutter-sm;
    }
  }
}

.page-footer__info {
  @media (min-width: $breakpoint-lg) {
    margin: 0;
  }
}

.page-footer__links {
  a {
    margin: 0 0.25em;
  }

  @media (min-width: $breakpoint-lg) {
    margin-bottom: 0;

    a {
      margin: 0 0.5em 0 0;
    }
  }

  @media (min-width: $breakpoint-xl) {
    a {
      margin: 0 0.25em 0 0;
    }
  }
}
</style>
